<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-12 text-center px-0">
        <canvas :id="name" :height="250"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
const AirbnbDatePicker = () => import('@/components/AirbnbDatePicker.vue')

/* eslint-disable */
export default {
  props: [
    'chartType',
    'referrer',
    'country',
    'url',
    'name',
    'boldTitle',
    'height',
    'clearState',
    'legend',
    'fullview',
    'startDate',
    'endDate',
    'data',
    'dataPrevious',
    'tz',
  ],
  store,
  components: {
    AirbnbDatePicker,
  },
  mounted() {
    this.loadData()
  },
  watch: {
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
        this.startDate = date.startDate
        this.endDate = date.endDate
        this.changePeriod()
      },
      deep: true,
    },
    '$store.getters.faces': {
      handler: function (value) {
        this.loadData()
      },
    },
  },
  methods: {
    changePeriod: function (value) {
      this.option = value
      // console.log(value)
      this.clearState = true
      this.loadData()
      this.clearState = false
    },
    loadData: function () {
      this.pageview = this.data
      this.pageviewPrevious = this.dataPrevious
      console.log(this.data)
      console.log(this.dataPrevious)
      this.loadChart()
      this.loading = false
    },
    loadChart: function () {
      const ctx2 = document.getElementById(this.name).getContext('2d')
      // const gradient = ctx2.createLinearGradient(0, 0, 0, 450)
      // gradient.addColorStop(0, 'rgba(0, 82, 205, 0.25)')
      // gradient.addColorStop(1, 'rgba(0, 82, 205, 0)')
      let previous = null
      var pageviewLine = 0
      var total = 0

      var data = {
        labels: [],
        datasets: [
          {
            data: [],
          },
          {
            data: [],
          },          
        ],
      }
      let selected = {
        start: this.$store.getters.datepicker.dashboard.startDate,
        end: this.$store.getters.datepicker.dashboard.endDate,
      }

      if (this.startDate) selected.start = this.startDate
      if (this.endDate) selected.end = this.endDate

      var s = this.$userTimeNow(selected.start)
      var e = this.$userTimeNow()
      if (selected.end) e = this.$userTimeNow(selected.end)

      if (-8 < Number(this.tz)) {
        e = e.add('days', 1)
      }

      // if it has end date and has a valid range of date
      if (selected.end && selected.start !== selected.end) {
        while (s.isBefore(e)) {
          data.labels.push(s.format('DD MMM YYYY'))
          s = s.add('days', 1)
        }
        data.labels.push(s.format('DD MMM YYYY'))

        if (-8 < Number(this.tz)) {
          data.labels.shift()
        }
      } else {
        for (let i = 0; i < 24; i++) {
          data.labels.push(i)
        }
      }

      var j = 0

      this.pageview.sort(function (a, b) {
        return moment(a.date) - moment(b.date)
      })

      this.pageviewPrevious.sort(function (a, b) {
        return moment(a.date) - moment(b.date)
      })      

      for (let i = 0; i < this.pageview.length; i++) {
        let current = this.pageview[i]
        pageviewLine = this.precisionRound(current.count, 1)
        total += current.count

        let currentdate = current.date

        if (!(selected.end && selected.start !== selected.end)) {
          while (
            typeof data.labels[j] !== 'undefined' &&
            currentdate != data.labels[j] 
            
          ) {
            data.datasets[0].data.push(0)
            j++
          }
        } else {
          currentdate = moment(this.pageview[i].date).format('DD MMM YYYY')
        }

        if (selected.end && selected.start !== selected.end) {
          while (
            typeof data.labels[j] !== 'undefined' &&
            currentdate != data.labels[j] &&
            previous !== currentdate 
          ) {
            data.datasets[0].data.push(0)
            j++
          }
        }

        if (previous === currentdate) {
          let last = data.datasets[0].data.pop()
          data.datasets[0].data.push(pageviewLine + last)
        } else {
          let color = localStorage.getItem('--main-color')

          // if (window.location.href.includes('howuku.com') || window.location.href.includes('localhost')) {
          //   color = '53, 64, 83'
          //   color = '82, 93, 194'
          // }
          

          data.datasets[0].data.push(pageviewLine)
          data.datasets[0].lineTension = 0
          if (this.chartType === 'bar') data.datasets[0].borderWidth = 0
          else data.datasets[0].borderWidth = 3
          data.datasets[0].borderColor =
            'rgba(' + color + ', 1)'

          if (this.chartType === 'bar')  data.datasets[0].backgroundColor = 'rgba(' + color + ', 1)'
          else data.datasets[0].backgroundColor = 'rgba(' + color + ', 0)'

          data.datasets[0].pointBackgroundColor = 'rgba(' + color + ', 1)'
          data.datasets[0].pointBorderWidth = '2'
          data.datasets[0].pointRadius = 3
          data.datasets[0].pointHoverRadius = 3

          data.datasets[0].pointHoverBackgroundColor = 'rgba(' + color + ', 1)'
          data.datasets[0].pointHoverBorderColor = 'rgba(' + color + ', 1)'

          if (this.chartType === 'bar') data.datasets[0].fillColor = 'rgba(192, 209, 227, 1)'
          // else data.datasets[0].fillColor = 'rgba(220,220,220,0.2)'
          

          data.datasets[0].strokeColor = 'rgba(220,220,220,1)'
          data.datasets[0].pointColor = 'rgba(220,220,220,1)'
          data.datasets[0].pointStrokeColor = '#fff'
          data.datasets[0].pointHighlightFill = '#fff'
          data.datasets[0].pointHighlightStroke = 'rgba(220,220,220,1)'
          data.datasets[0].label = 'Pageviews'
        }
        if (previous !== currentdate) j++
        previous = currentdate
      }

      for (let i = 0; i < this.pageviewPrevious.length; i++) {
        let current = this.pageviewPrevious[i]
        pageviewLine = this.precisionRound(current.count, 1)
        // total += current.count

        let currentdate = current.date

        if (!(selected.end && selected.start !== selected.end)) {
          while (
            typeof data.labels[j] !== 'undefined' &&
            currentdate != data.labels[j] 
            
          ) {
            data.datasets[1].data.push(0)
            j++
          }
        } else {
          currentdate = moment(this.pageviewPrevious[i].date).format('DD MMM YYYY')
        }

        if (selected.end && selected.start !== selected.end) {
          while (
            typeof data.labels[j] !== 'undefined' &&
            currentdate != data.labels[j] &&
            previous !== currentdate 
          ) {
            data.datasets[1].data.push(0)
            j++
          }
        }

        if (previous === currentdate) {
          let last = data.datasets[1].data.pop()
          data.datasets[1].data.push(pageviewLine + last)
        } else {
          let color = localStorage.getItem('--main-color')
          let opacity = 0.4

          if (window.location.href.includes('howuku.com') || window.location.href.includes('localhost')) {
            color = '184, 201, 246'
            opacity = 1

            if (this.chartType === 'line') {
              color = '228, 228, 228'
              opacity = 1              
            }
          }
          

          data.datasets[1].data.push(pageviewLine)
          data.datasets[1].lineTension = 0
          if (this.chartType === 'bar') data.datasets[1].borderWidth = 0
          else data.datasets[1].borderWidth = 3
          data.datasets[1].borderColor ='rgba(' + color + ', ' + opacity + ')'

          if (this.chartType === 'bar')  data.datasets[1].backgroundColor = 'rgba(' + color + ', ' + opacity + ')'
          else data.datasets[1].backgroundColor = 'rgba(' + color + ', 0)'

          if (this.chartType === 'bar')  data.datasets[1].backgroundColor = 'rgba(' + color + ', ' + opacity + ')'
          else data.datasets[1].borderDash = [10, 10]
          

          data.datasets[1].pointBackgroundColor = 'rgba(' + color + ', ' + opacity + ')'
          data.datasets[1].pointBorderWidth = '2'
          data.datasets[1].pointRadius = 3
          data.datasets[1].pointHoverRadius = 3

          data.datasets[1].pointHoverBackgroundColor = 'rgba(' + color + ', ' + opacity + ')'
          data.datasets[1].pointHoverBorderColor = 'rgba(' + color + ', ' + opacity + ')'

          if (this.chartType === 'bar') data.datasets[1].fillColor = 'rgba(' + color + ', ' + opacity + ')'
          // else data.datasets[1].fillColor = 'rgba(220,220,220,0.2)'
          

          data.datasets[1].strokeColor = 'rgba(220,220,220,1)'
          data.datasets[1].pointColor = 'rgba(220,220,220,1)'
          data.datasets[1].pointStrokeColor = '#fff'
          data.datasets[1].pointHighlightFill = '#fff'
          data.datasets[1].pointHighlightStroke = 'rgba(220,220,220,1)'
          data.datasets[1].label = 'Previous'
        }
        if (previous !== currentdate) j++
        previous = currentdate
      }

      if (!(selected.end && selected.start !== selected.end)) {
        for (let i in data.labels) {
          let time = []
          time.push(data.labels[i])
          time[1] = time[0] < 12 ? 'AM' : 'PM'

          time[0] = time[0] % 12 || 12
          data.labels[i] = time.join('')
        }
      }

      for (let i in data.labels) {
        if (!data.datasets[1].data[i]) {
          data.datasets[1].data[i] = 0
        }
      }

      this.$emit('total', total)

      if (!this.chartType) this.chartType = 'bar'

      if (this.chart !== undefined) this.chart.destroy()

      let ctx = document.getElementById(this.name)

      import('chart.js').then(Chart => {
        this.chart = new Chart(ctx, {
          pointHitDetectionRadius: 20,

          // eslint-disable-line no-new
          type: this.chartType,
          data: data,
          options: {
            tooltips: {
              callbacks: {
                // label: function(tooltipItem, data) {
                //   var label = data.datasets[tooltipItem.datasetIndex].label || '';
                //   label += tooltipItem.yLabel;
                //   return label;
                // },
                title: function(tooltipItems, data) {
                  var label = data.labels[tooltipItems[0].index];
                  return !label.includes('PM') && !label.includes('AM') ? moment(label).format('DD MMM (ddd)') : label; // Add additional information to the title
                },              
              },            
              mode: 'index',
              intersect: false,
            },
            hover: {
              mode: 'nearest',
              intersect: true,
            },
            elements: {
              point: {
                radius: 2,
              },
            },
            maintainAspectRatio: false,
            onClick: (evt, item) => {
              if (item[0]) {
                let label = data.labels[item[0]['_index']]
                console.log(label)
                this.$emit('searchtime', label)
              }
            },
            legend: {
              display: this.legend ? true : false,
            },
            scales: {
              xAxes: [
                {
                  barPercentage: 0.5,
                  gridLines: {
                    color: 'rgba(0, 0, 0, 0)',
                  },
                  stacked: true,
                  ticks: {
                    callback: function(value, index, values) {
                      return (!value.includes('AM') && !value.includes('PM')) ? value.slice(0, -4) : value; // Remove the trailing 4 characters
                    },                  
                    // maxRotation: 0,
                    autoSkip: false,
                    maxTicksLimit: 12,
                  },
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    color: '#e5e5e5',
                  },
                  stacked: false,
                  ticks: {
                    min: 0,
                    beginAtZero: true,
                    autoSkip: true,
                    maxTicksLimit: 8,
                  },
                },
              ],
            },
            defaultFontSize: 16,
            layout: {
              padding: {
                top: 30,
              },
            },
          },
        })
      })
    },
    diff: function (date1, date2) {
      let dt1 = new Date(date1)
      let dt2 = new Date(date2)
      return Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      )
    },
    precisionRound: function (number, precision) {
      var factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
  data: function () {
    return {
      option: 'all',
      chart: undefined,
      clearState: false,
      startDate: '',
      endDate: '',
      pageview: null,

      uniqueview: null,
      loading: true,
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/PageviewBarChart.vue